import React from 'react';

const LoadingScreen = () => {
  return (
    <div className="fixed inset-0 bg-[#111111] z-50 flex flex-col items-center justify-center">
      <div className="relative animate-float">
        <img 
          src="https://i.postimg.cc/fJxNP8LM/lc-logo.png" 
          alt="Cardinals Logo"
          className="w-64 h-64 object-contain animate-pulse-slow"
          loading="eager"
        />
      </div>
      <div className="mt-8 flex flex-col items-center">
        <div className="h-1.5 w-48 bg-cardinal/20 rounded-full overflow-hidden shadow-inner-lg">
          <div className="h-full w-full bg-gradient-to-r from-cardinal via-cardinal-hover to-cardinal animate-loading-bar transform origin-left" />
        </div>
        <p className="mt-4 text-white/70 text-sm font-medium tracking-wider animate-pulse">
          LOADING
          <span className="inline-flex ml-1">
            <span className="animate-[bounce_1s_infinite]">.</span>
            <span className="animate-[bounce_1s_infinite_.2s]">.</span>
            <span className="animate-[bounce_1s_infinite_.4s]">.</span>
          </span>
        </p>
      </div>
    </div>
  );
};

export default LoadingScreen;